import styled from "styled-components";

export const CompanyLogo = styled.img.attrs(() => ({ "data-cy": "company-logo" }))`
  height: 40px;
  width: 40px;
`;
